import { useEffect, useState } from "react";
import { Home, Search, Wifi } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";

const fmtBytes = (b) => (b >= 1e9 ? `${(b / 1e9).toFixed(2)} GB` : b >= 1e6 ? `${(b / 1e6).toFixed(1)} MB` : b >= 1e3 ? `${(b / 1e3).toFixed(0)} KB` : `${b} B`);

export function OnlineUsersDialog({ routerId, kind, onClose }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!kind) return;
    setRows(null); setErr(""); setQ("");
    api.get(`/traffic/${routerId}/online/${kind}`).then((r) => setRows(r.data)).catch((e) => setErr(errMsg(e)));
  }, [routerId, kind]);
  const isHs = kind === "hotspot";
  const list = (rows || []).filter((r) => !q || `${r.name} ${r.address} ${r.mac}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={!!kind} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] flex flex-col" data-testid="dialog-online-users">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">{isHs ? <Wifi className="w-5 h-5 text-sky-500" /> : <Home className="w-5 h-5 text-violet-500" />} {isHs ? "Hotspot" : "Rumahan (PPPoE)"} Online{rows && <span className="text-sm font-normal text-muted-foreground">— {rows.length} user</span>}</DialogTitle>
          <DialogDescription>Daftar user yang sedang terhubung ke router saat ini.</DialogDescription>
        </DialogHeader>
        <div className="relative"><Search className="w-4 h-4 absolute left-2.5 top-3 text-muted-foreground" /><Input className="pl-8" placeholder="Cari nama / IP / MAC…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="online-search" /></div>
        <div className="flex-1 overflow-y-auto rounded-lg border border-border">
          {!rows && !err && <div className="p-6 text-center text-sm text-muted-foreground animate-pulse">Membaca router…</div>}
          {err && <div className="p-6 text-center text-sm text-rose-500" data-testid="online-error">{err}</div>}
          {rows && list.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground" data-testid="online-empty">Tidak ada user online.</div>}
          {list.length > 0 && (
            <table className="w-full text-xs">
              <thead className="sticky top-0 bg-card border-b border-border text-left text-muted-foreground">
                <tr><th className="px-3 py-2">#</th><th className="px-3 py-2">User</th><th className="px-3 py-2">IP</th><th className="px-3 py-2">{isHs ? "MAC" : "Caller-ID"}</th><th className="px-3 py-2">Uptime</th>{isHs && <th className="px-3 py-2 text-right">↓ / ↑</th>}</tr>
              </thead>
              <tbody className="divide-y divide-border">
                {list.map((r, i) => (
                  <tr key={`${r.name}-${r.address}-${i}`} className="hover:bg-accent/40" data-testid={`online-row-${r.name}`}>
                    <td className="px-3 py-1.5 text-muted-foreground">{i + 1}</td>
                    <td className="px-3 py-1.5 font-semibold">{r.name}</td>
                    <td className="px-3 py-1.5 font-mono">{r.address}</td>
                    <td className="px-3 py-1.5 font-mono text-muted-foreground">{r.mac}</td>
                    <td className="px-3 py-1.5 font-mono">{r.uptime}</td>
                    {isHs && <td className="px-3 py-1.5 font-mono text-right text-muted-foreground">{fmtBytes(r.rx)} / {fmtBytes(r.tx)}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
